import { TicketTypeFilter } from '@/app/modules/seating/guestOperations/Picker/domain/enums/TicketTypeFilter';
import { TicketStatusFilter } from '@/app/modules/seating/guestOperations/Picker/domain/enums/TicketStatusFilter';
import { isTicketDistributed } from '@/app/modules/seating/guestOperations/Picker/domain/tickets/tickets';
import { ProtocolHeartStatusFilter } from '@/app/modules/seating/guestOperations/Picker/domain/enums/ProtocolHeartStatusFilter';

export const filterTicketsTree = (tree, filters) => {
    const activeFilters = Object.values({
        byQuery: filters.query ? (item) => filterByQuery(item, filters.query) : undefined,
        byProtocol: filters.protocol
            ? (item) => filterByProtocol(item, filters.protocol)
            : undefined,
        byTicketType: filters.ticketType
            ? (item) => filterByTicketType(item, filters.ticketType)
            : undefined,
        byStatus: filters.status ? (item) => filterByStatus(item, filters.status) : undefined,
        byParticipantGroup: filters.participantGroup
            ? (item) => filterByParticipantGroup(item, filters.participantGroup)
            : undefined,
        byParticipantStatus: filters.participantStatus
            ? (item) => filterByParticipantStatus(item, filters.participantStatus)
            : undefined,
        byOnlyLastMinuteChanged:
            filters.onlyLastMinuteChanged === true
                ? (item) => filterByOnlyLastMinuteChanged(item)
                : undefined,
        byProtocolHeartStatus: filters.protocolHeartStatus
            ? (item) => filterByProtocolHeartStatus(item, filters.protocolHeartStatus)
            : undefined,
        byNotAllocated: filters.onlyNotAllocated
            ? (item) => filterByOnlyNotAssigned(item)
            : undefined,
        byOnlyAssignedToAreaId: filters.onlyAssignedToAreaId
            ? (item) => filterByOnlyAssignedToArea(item, filters.onlyAssignedToAreaId)
            : undefined,
    }).filter(Boolean);

    if (activeFilters.length === 0) {
        return tree;
    }

    return tree.filter((item) => {
        return (
            activeFilters.every((filter) => filter(item)) ||
            item.nestedTickets.some((nestedItem) =>
                activeFilters.every((filter) => filter(nestedItem))
            )
        );
    });
};

const filterByQuery = (item, query) => {
    const criteria = query.split(' ').map((part) => part.toLocaleLowerCase());
    return criteria.every((searchValue) => {
        return (
            item.guest.given_name.toLocaleLowerCase().includes(searchValue) ||
            item.guest.family_name.toLocaleLowerCase().includes(searchValue) ||
            item.guest.popular_name.toLocaleLowerCase().includes(searchValue) ||
            item.guest.organization?.toLocaleLowerCase().includes(searchValue)
        );
    });
};

const filterByProtocol = (item, protocol) => item.guest.protocol === protocol;

const filterByTicketType = (item, ticketType) => {
    if (ticketType === TicketTypeFilter.CAT1) {
        return item.ticket_type === TicketTypeFilter.CAT1;
    }
    if (ticketType === TicketTypeFilter.CAT2) {
        return item.ticket_type === TicketTypeFilter.CAT2;
    }
    if (ticketType === TicketTypeFilter.STANDARD) {
        return item.ticket_type === TicketTypeFilter.STANDARD;
    }

    return true;
};

const filterByStatus = (item, status) => {
    const isTicketAssignedToSeat = !!item.venue_seat_id;
    if (status === TicketStatusFilter.NOT_ASSIGNED) {
        return !isTicketAssignedToSeat && !item.on_waiting_list;
    }

    if (status === TicketStatusFilter.NOT_ASSIGNED_AND_ON_WAITING_LIST) {
        return !isTicketAssignedToSeat || item.on_waiting_list;
    }

    if (status === TicketStatusFilter.ASSIGNED) {
        return isTicketAssignedToSeat;
    }

    if (status === TicketStatusFilter.DISTRIBUTED) {
        return isTicketDistributed(item);
    }

    if (status === TicketStatusFilter.DISTRIBUTION_ROLLED_BACK) {
        return item.was_distribution_rolled_back;
    }

    return true;
};

const filterByParticipantGroup = (item, participantGroupId) =>
    item.guest.participant_group?.id === participantGroupId;

const filterByParticipantStatus = (item, participantStatus) =>
    item.guest.ifes_approval_state === participantStatus;

const filterByOnlyLastMinuteChanged = (item) => item.last_minute_change === true;

const filterByProtocolHeartStatus = (item, status) => {
    if (status === ProtocolHeartStatusFilter.ONLY_PROTOCOL_HEART) {
        return item.seat?.is_protocol_heart === true;
    }

    if (status === ProtocolHeartStatusFilter.ONLY_NON_PROTOCOL_HEART) {
        return item.seat?.is_protocol_heart === false;
    }

    return true;
};

const filterByOnlyNotAssigned = (item) => {
    return !item.venue_seat_id && !item.on_waiting_list;
};

const filterByOnlyAssignedToArea = (item, areaId) => {
    return item.seat?.category?.seat_group?.id === areaId;
};
